<template>
  <div
    id="card-report-downloaded"
    :class="`card card-download-report ${classRight}`"
    v-show="$store.state.report.isPopupDownload"
  >
    <div class="card-header header bg-primary">
      <div class="row align-items-center">
        <div class="col-md-8">
          {{ popupTitle }}
          <span
            v-if="processDownload.length > 0"
            class="mx-2 spinner-border spinner-border-sm text-white"
          ></span>
        </div>
        <div class="col-md-4 d-flex justify-content-end header-btn">
          <div class="font-size-20 mx-2" @click="toggleList">
            <i :class="`mc-icon icon-white icon-outline_chevron-${expandList ? 'up' : 'down'}`"></i>
          </div>
          <div class="font-size-20" @click="closePopup">&times;</div>
        </div>
      </div>
    </div>
    <div class="card-body body" v-if="expandList">
      <div class="title mb-2" @click="toggleDoneList">
        {{ `${$t('report.download.complete')} (${successDownload.length})` }}
        <div class="d-flex float-end">
          <i :class="`mc-icon icon-outline_chevron-${openDoneList ? 'up' : 'down'}`"></i>
        </div>
      </div>
      <div v-if="openDoneList" class="mb-3">
        <div class="download-list" v-for="(success, index) in successDownload" :key="index">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <i
                  :class="
                    ['xlsx', 'csv'].includes(success.type)
                      ? 'icon icon-fill_excel'
                      : 'icon icon-fill_pdf'
                  "
                  :alt="success.type"
                ></i>
              </div>
              <div class="me-2">
                <div class="download-list__title d-flex align-items-center gap-1">
                  <span class="download-title">{{ success.name }}</span>
                  <i
                    :id="`too-big-tooltip-${index}`"
                    class="icon-outline_info"
                    v-if="success.status == 'I' && success.isHuge"
                  ></i>
                  <b-tooltip
                    :target="`too-big-tooltip-${index}`"
                    triggers="hover"
                    placement="right"
                    custom-class="formulate-input-tooltip"
                  >
                    {{ $t('report.text.tooBigReport') }}
                  </b-tooltip>
                </div>
                <div class="d-flex align-items-center">
                  <div class="download-list__periode">
                    {{ success.type.toUpperCase() }}
                  </div>
                  <span class="px-2 mb-1 bullet"> &bull; </span>
                  <div class="download-list__periode">
                    {{ success.downloadedAt }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <McButton
                v-if="success.status == 'D'"
                icon="icon-outline_download"
                class="btn-download"
                text=""
                variant="primary"
                @click="downloadHistory(success.url)"
              />
              <div class="spinner-report" v-else-if="success.status == 'I'">
                <b-spinner small class="align-middle"></b-spinner>
              </div>
            </div>
          </div>
        </div>
        <div v-if="successDownload.length == 0" class="text-center">
          {{ $t('global.action.noDownloadProcess') }}
        </div>
      </div>
      <div class="title mb-2" @click="toggleRunningList">
        {{ `${$t('report.download.running')} (${processDownload.length})` }}
        <div class="d-flex float-end">
          <i :class="`mc-icon icon-outline_chevron-${openRunningList ? 'up' : 'down'}`"></i>
        </div>
      </div>
      <div v-if="openRunningList" class="mb-3">
        <div class="download-list" v-for="(download, index) in processDownload" :key="index">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <i
                  :class="
                    ['xlsx', 'csv'].includes(download.type)
                      ? 'icon icon-fill_excel'
                      : 'icon icon-fill_pdf'
                  "
                  :alt="download.type"
                ></i>
              </div>
              <div class="me-2">
                <div class="download-list__title d-flex align-items-center gap-1">
                  <span class="download-title">{{ download.name }}</span>
                  <i
                    :id="`too-big-tooltip-${index}`"
                    class="icon-outline_info"
                    v-if="download.status == 'I' && download.isHuge"
                  ></i>
                  <b-tooltip
                    :target="`too-big-tooltip-${index}`"
                    triggers="hover"
                    placement="right"
                    custom-class="formulate-input-tooltip"
                  >
                    {{ $t('report.text.tooBigReport') }}
                  </b-tooltip>
                </div>
                <div class="d-flex align-items-center">
                  <div class="download-list__periode">
                    {{ download.type.toUpperCase() }}
                  </div>
                  <span class="px-2 mb-1 bullet"> &bull; </span>
                  <div class="download-list__periode">
                    {{ download.downloadedAt }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <McButton
                v-if="download.status == 'D'"
                icon="icon-outline_download"
                class="btn-download"
                text=""
                variant="primary"
                @click="downloadHistory(download.url)"
              />
              <div class="spinner-report" v-else-if="download.status == 'I'">
                <b-spinner small class="align-middle"></b-spinner>
              </div>
            </div>
          </div>
        </div>
        <div v-if="processDownload.length == 0" class="text-center">
          {{ $t('global.action.noDownloadProcess') }}
        </div>
      </div>
      <div class="title mb-2" @click="toggleStoppedList">
        {{ `${$t('report.download.stop')} (${listError.length})` }}
        <div class="d-flex float-end">
          <i :class="`mc-icon icon-outline_chevron-${openStoppedList ? 'up' : 'down'}`"></i>
        </div>
      </div>
      <div v-if="openStoppedList" class="mb-3">
        <div class="download-list error" v-for="failed in listError">
          <div class="download-list__error">
            <div class="download-list__error--list">
              <div class="d-flex align-items-center">
                <div class="me-2">
                  <i
                    :class="
                      ['xlsx', 'csv'].includes(failed.type)
                        ? 'icon icon-fill_excel'
                        : 'icon icon-fill_pdf'
                    "
                    :alt="failed.type"
                  ></i>
                </div>
                <div class="me-2">
                  <div class="download-list__title">
                    <span class="download-title">{{ failed.name }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="icon-fill_alert-triangle error pe-1"></i>
                    <span class="error">{{ $t('global.action.failDownload') }}</span>
                    <span class="px-2 mb-1 bullet"> &bull; </span>
                    <div class="download-list__periode">
                      {{ failed.type.toUpperCase() }}
                    </div>
                    <span class="px-2 mb-1 bullet"> &bull; </span>
                    <div class="download-list__periode">
                      {{ failed.downloadedAt }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="listError.length == 0" class="text-center">
          {{ $t('global.action.noDownloadProcess') }}
        </div>
      </div>
      <McButton
        icon="icon-fill_external-link"
        :text="$t('global.action.viewDownload')"
        class="btn-download float-end mt-2"
        variant="secondary"
        iconPosition="right"
        @click="openModalDownload()"
      />
    </div>
    <ModalDownloadHistory ref="modalDownloadHistoryRef" />
    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete"
      :title="$t('report.download.cancelDownload')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('report.download.modalMsg') }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            @click="cancel()"
            class="me-2"
            :text="$t('report.download.no')"
          />
          <McButton @click="toDelete" :text="$t('report.download.yes')" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'
import { UPDATE_DOWNLOAD_HISTORY, GET_DOWNLOAD_HISTORIES } from '@/services/api/report/report'
import ModalDownloadHistory from '@/router/views/report/components/ModalDownloadHistory.vue'
export default {
  components: {
    McButton,
    ModalDownloadHistory,
  },
  mixins: [Helper],
  apollo: {
    downloadHistory: {
      query: GET_DOWNLOAD_HISTORIES,
      variables() {
        return {
          filter: {
            orderBy: [JSON.stringify({ downloadOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.downloadHistories = data.downloadHistory.downloadHistory
        }
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  mounted() {
    this.intervalCheckingReport()
  },
  data() {
    return {
      loading: 0,
      modalOpen: 'progress',
      selected: {},
      expandList: false,
      excelIcon: require('@/assets/images/download-format/excel.png'),
      pdfIcon: require('@/assets/images/download-format/pdf.png'),
      openDoneList: true,
      openRunningList: true,
      openStoppedList: false,
      downloadHistories: [],
      interval: null,
      currentCountInterval: 0,
      maxIntervalLoop: 10,
      currentSecondInterval: 10,
      incrementInterval: 10,
    }
  },
  computed: {
    ...mapGetters('report', ['showProgress']),
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    listError() {
      return this.$store.state.report.failedDownload
    },
    popupTitle() {
      return this.$store.state.report.downloadProcess.length > 0
        ? this.$t('report.download.preparing')
        : this.listError > 0
        ? this.$t('report.download.fail')
        : this.$t('report.download.success')
    },
    classRight() {
      return JSON.parse(this.getFeatureFlagData('freshchat_support_customized').value).show &&
        JSON.parse(this.getFeatureFlagData('freshchat_support_customized').value).custom_button &&
        this.hasAccess(['0e0-base-livechat:read'])
        ? 'fixed-right'
        : ''
    },
    fcOpened() {
      return this.$store.state.freshchat.fcOpened
    },
    successDownload() {
      return this.$store.state.report.successDownload.filter((item) => item.status == 'D')
    },
    processDownload() {
      return this.$store.state.report.successDownload.filter((item) => item.status == 'I')
    },
  },
  watch: {
    fcOpened(newValue) {
      if (newValue) {
        document.getElementById('card-report-downloaded').style.right = '450px'
      } else {
        document.getElementById('card-report-downloaded').style.right = '185px'
      }
    },
    popupTitle(value) {
      if (value == this.$t('report.download.success')) this.expandList = true
    },
    processDownload(value) {
      const successDownload = value.filter((item) => item.status == 'I')
      if (successDownload.length <= 0) {
        clearInterval(this.interval)
      } else {
        this.intervalCheckingReport()
      }
    },
    currentCountInterval(value) {
      if (value == this.maxIntervalLoop) {
        this.currentSecondInterval += this.incrementInterval
        clearInterval(this.interval)
        this.intervalCheckingReport()
      }
    },
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    intervalCheckingReport() {
      this.currentCountInterval = 0
      this.interval = setInterval(async () => {
        let successDownload = this.processDownload.filter((item) => item.status == 'I')
        if (successDownload.length <= 0) {
          clearInterval(this.interval)
          return
        }
        await this.$apollo.queries.downloadHistory.refetch()
        this.currentCountInterval++
        for (const dp of successDownload) {
          const download = this.downloadHistories.find((item) => item.downloadHistoryId == dp.id)
          const status = this.getDownloadCondition(download)
          if (status == 'D') {
            this.$store.commit('report/updateDoneProgress', {
              id: download?.downloadHistoryId,
              url: download?.url,
              status: download?.status,
            })
          } else if (status == 'F') {
            this.$store.commit('report/failingProgress', {
              id: download?.downloadHistoryId,
              url: download?.url,
              status: download?.status,
            })
          } else {
            this.$store.commit('report/updatePendingProgress', {
              id: download?.downloadHistoryId,
              isHuge: download?.isHuge,
            })
          }
        }
      }, this.currentSecondInterval * 1000)
    },
    getDownloadCondition(item) {
      if (!item) return 'I'
      if (
        item.status == 'D' &&
        item.url &&
        item.url.length > 0 &&
        item.url.filter((u) => u !== null).length === item.url.length
      ) {
        return 'D'
      } else if (
        item.status === 'F' ||
        (item.status === 'I' &&
          new Date().getTime() - new Date(item.downloadOn).getTime() > 1000 * 3600 * 12)
      ) {
        return 'F'
      } else {
        return 'I'
      }
    },
    downloadHistory(urls) {
      const downloadFileWithAnchor = (url) => {
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = url.substring(url.lastIndexOf('/') + 1)
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
      }
      if (urls && urls.length > 0) {
        const urlsFinal = urls.filter((item) => item !== null && item.length > 0)
        const timeout = urlsFinal.length > 1 ? Math.ceil(urlsFinal.length / 2) * 1000 : 1000
        for (let index = 0; index < urlsFinal.length; index++) {
          setTimeout(() => {
            downloadFileWithAnchor(urlsFinal[index])
          }, timeout * index)
        }
      }
    },
    toggleList() {
      this.expandList = !this.expandList
    },
    toggleDoneList() {
      this.openDoneList = !this.openDoneList
    },
    toggleRunningList() {
      this.openRunningList = !this.openRunningList
    },
    toggleStoppedList() {
      this.openStoppedList = !this.openStoppedList
    },
    closePopup() {
      this.$store.commit('report/showDownloadPopup', false)
    },
    openModalDownload(id) {
      this.closePopup()
      this.$refs.modalDownloadHistoryRef.toDownloadHistory(id)
    },
    cancelDownload(data) {
      this.selected = data
      this.$bvModal.show('modal-delete')
    },
    toDelete() {
      if (self.selected.id) {
        const self = this

        this.$apollo
          .mutate({
            mutation: UPDATE_DOWNLOAD_HISTORY,
            variables: {
              input: {
                downloadHistoryId: [self.selected.id],
                status: 'C',
              },
            },
          })
          .then(() => {
            self.$mcToast.success(this.$t('global.alert.text.downloadCancelled'))
            self.$bvModal.hide('modal-delete')
            self.$parent.$parent.$parent.refreshDownloadHistory()
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.icon-white:before {
  color: #fff !important;
}

.fixed-right {
  right: 185px;
}

.card-download-report {
  margin-bottom: 12px;
}

#card-report-downloaded {
  width: 500px !important;
}

.download-title {
  width: 340px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.icon::before {
  font-size: 30px;
}

.mc-button {
  margin-top: 0 !important;
}

.download-list__periode {
  margin-top: 0 !important;
}

.bullet {
  font-size: 20px;
  line-height: 5px;
}

.spinner-report {
  padding: 12px;
  background-color: rgb(206, 203, 203);
  border-radius: 5px;
}

.icon-fill_alert-triangle::before {
  font-size: 14px;
  color: #f46a6a !important;
}

.error {
  color: #f46a6a !important;
}
</style>
